import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import CarTypes from './CarTypes';
import Categories from './Categories';
import Zones from './Zones';
import Countries from './Countries';
import { useLocation} from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Pricing() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const {state} = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: { xs: 'calc(100vw - 30px)', sm: '100%' } }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="pricing tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab style={{marginRight:"20px"}} label={t('car_type')} {...a11yProps(0)} />
          <Tab style={{marginRight:"20px"}} label={t('categories')} {...a11yProps(1)} />
          <Tab style={{marginRight:"20px"}} label={t('countries')} {...a11yProps(2)} />
          <Tab style={{marginRight:"20px"}} label={t('zones')} {...a11yProps(3)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <CarTypes pageNo={state?.pageNo}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Categories/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Countries/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Zones/>
      </TabPanel>
    </Box>
  );
}